import * as React from 'react';
import { basePageWrap } from '../BasePage';

import { Image } from '../../types';

import Streamfield from '../../components/Streamfield';
import WideImage from '../../components/WideImage';
import Preamble from '../../components/Preamble';
import CardArticleList from '../../components/CardArticleList';
import Author, { AuthorProps } from '../../components/Author/Author';

import s from './PageArticle.module.scss';

interface PageArticleProps {
    title: string;
    featuredImage: Image;
    content: any[];
    relatedArticles: any[];
    author: AuthorProps;
    renderedPreamble: string;
}

class PageArticle extends React.PureComponent<PageArticleProps> {
    state = {};

    static defaultProps = {};

    render() {
        const {
            title,
            featuredImage,
            content,
            relatedArticles,
            author,
            renderedPreamble,
        } = this.props;
        return (
            <div className={s.Root}>
                <h1 className={s.Title}>{title}</h1>
                <div className={s.Author}>
                    {author && author.fullName && <Author {...author} />}
                </div>
                {renderedPreamble && <Preamble preamble={renderedPreamble} />}
                {featuredImage && (
                    <WideImage image={featuredImage} featuredImage={true} />
                )}
                <Streamfield items={content} pageType="PageArticle" />
                {relatedArticles && (
                    <div className={s.Related}>
                        <h2 className={s.RelatedTitle}>Relaterade artiklar</h2>
                        <CardArticleList items={relatedArticles} />
                    </div>
                )}
            </div>
        );
    }
}

export default basePageWrap(PageArticle);
